import { OrganizationEmailType } from 'generated/graphql';

export const emailTypeLabel = {
	[OrganizationEmailType.EmailTo]: 'Normální',
	[OrganizationEmailType.EmailCc]: 'Kopie',
	[OrganizationEmailType.EmailBcc]: 'Skrytá kopie',
};

export const emailTypeOptions = [
	{ value: OrganizationEmailType.EmailTo, label: 'Normální' },
	{ value: OrganizationEmailType.EmailCc, label: 'Kopie' },
	{ value: OrganizationEmailType.EmailBcc, label: 'Skrytá kopie' },
];
